import React from 'react';
import { useNavigate } from 'react-router-dom';
import nb from './images/Neobot.png';

const MainPage = () => {
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem('userEmail');

  // Redirect to signin if userEmail is missing
  if (!userEmail) {
    navigate('/signin');
    return null;
  }

  // Function to send folder creation info
  const sendButtonInfo = async (buttonName) => {
    try {
      const response = await fetch('https://neobot.d-rosa.ai/api/user_folder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          path: `/var/www/neobot/myflaskapp/flask_static/${userEmail}`,
          folder_name: buttonName,
        }),
      });

      if (response.ok) {
        console.log('Data sent successfully');
      } else {
        console.error('Failed to send data');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // Handle Neobot button click
  const handleNavigate7 = async () => {
    await sendButtonInfo('NeoBot_Pizza');
    navigate('/neobot_pizza');
  };

  // Handle Truck Body button click
  const handleNavigate8 = async () => {
    await sendButtonInfo('Truck');
    navigate('/neobot_truck');
  };

// Handle Neobot Manufacturing button click
  const handleNavigate9 = async () => {
    await sendButtonInfo('NeoBot');
    navigate('/neobot');
  };


  return (
    <div
      style={{
        textAlign: 'center',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(to bottom, #EAF6FF, #CFE8FF)',
        fontFamily: 'Arial, sans-serif',
        position: 'relative',
        paddingBottom: '60px',
      }}
    >
      {/* Title */}
      <h1
        style={{
          marginTop: '80px',
          fontSize: '36px',
          fontWeight: 'bold',
          color: '#222',
        }}
      >
        Welcome to <span style={{ color: '#007BFF' }}>Neobot</span>
      </h1>

      {/* Signed-in Email */}
      <p style={{ marginTop: '10px', fontSize: '16px', color: '#444' }}>
        Signed in as: <b>{userEmail}</b>
      </p>

      {/* Buttons stacked vertically */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '50px',
          gap: '40px',
        }}
      >
        {/* Neobot (Pizza) */}
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={handleNavigate7}
            style={{
              background: 'linear-gradient(to bottom, #EAF6FF, #CFE8FF)',
              border: 'none',
              borderRadius: '15px',
              padding: '15px',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s',
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = 'scale(1.05)')
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.transform = 'scale(1)')
            }
          >
            <img
              src={nb}
              className="app-img"
              width="140"
              height="120"
              alt="Neobot"
              style={{ borderRadius: '10px' }}
            />
          </button>
          <div
            className="app-label"
            style={{ marginTop: '10px', fontSize: '16px', color: '#007BFF' }}
          >
            Pizza
          </div>
        </div>

        {/* Truck Chassis */}
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={handleNavigate8}
            style={{
              background: 'linear-gradient(to bottom, #EAF6FF, #CFE8FF)',
              border: 'none',
              borderRadius: '15px',
              padding: '15px',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s',
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = 'scale(1.05)')
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.transform = 'scale(1)')
            }
          >
            <img
              src={nb}
              className="app-img"
              width="140"
              height="120"
              alt="Truck Body"
              style={{ borderRadius: '10px' }}
            />
          </button>
          <div
            className="app-label"
            style={{ marginTop: '10px', fontSize: '16px', color: '#007BFF' }}
          >
            Truck Body
          </div>
        </div>

        {/* Neobot Manufacturing */}
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={handleNavigate9}
            style={{
              background: 'linear-gradient(to bottom, #EAF6FF, #CFE8FF)',
              border: 'none',
              borderRadius: '15px',
              padding: '15px',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s',
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = 'scale(1.05)')
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.transform = 'scale(1)')
            }
          >
            <img
              src={nb}
              className="app-img"
              width="140"
              height="120"
              alt="Neobot Manufacturing"
              style={{ borderRadius: '10px' }}
            />
          </button>
          <div
            className="app-label"
            style={{ marginTop: '10px', fontSize: '16px', color: '#007BFF' }}
          >
            Neobot Manufacturing
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer
        style={{
          backgroundColor: '#0b2e59',
          color: 'white',
          textAlign: 'center',
          padding: '15px 0',
          position: 'absolute',
          bottom: '0',
          width: '100%',
          fontSize: '14px',
          marginTop: '20px',
        }}
      >
        � 2022 HYDAX Pvt. Ltd. All rights reserved.
      </footer>
    </div>
  );
};

export default MainPage;
